import React from 'react';

export interface CourseItem {
  id: number;
  name: string;
  code: string;
  year: number;
}

interface CourseContextValue {
  courses: CourseItem[];
  loading: boolean;
  selectedCourseId: number | null;
  selectedCourse: CourseItem | null;
  reload: () => void;
  selectCourse: (courseId: number) => Promise<void>;
}

const CourseContext = React.createContext<CourseContextValue>({
  courses: [],
  loading: true,
  selectedCourseId: null,
  selectedCourse: null,
  reload: () => {},
  selectCourse: async () => {},
});

export default CourseContext;
